import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss']
})
export class PrimaryButtonComponent implements OnInit {

  @Input() buttonText: string = '';
  @Input() buttonClass: string = '';
  @Input() isDisabled: boolean = false;
  @Input() inputType: string = 'button';

  constructor() { }

  ngOnInit() {
  }

}
